import React from 'react';
import {
  DashboardOutlined,
  DesktopOutlined,
  FileTextOutlined,
  TeamOutlined,
  BarChartOutlined,
  CloudServerOutlined,
  UserOutlined,
  SettingOutlined,
  SafetyOutlined,
  CodeOutlined,
  HomeOutlined,
  ApartmentOutlined,
  GroupOutlined,
  DownloadOutlined,
  FileProtectOutlined,
  CustomerServiceOutlined,
  MailOutlined
} from '@ant-design/icons';
import i18n from '../i18n';
const IS_CUSTOMER_BUILD = process.env.REACT_APP_BUILD_TARGET === 'customer';
const SUPPORT_AGENT_ROLE = IS_CUSTOMER_BUILD ? '' : ['support', 'agent'].join('_');
const SUPPORT_TICKETS_PATH = IS_CUSTOMER_BUILD ? '' : `/${['support', 'tickets'].join('-')}`;
const SUPPORT_TICKETS_LABEL_KEY = ['navbar', 'menu', ['support', 'tickets'].join('_')].join('.');
const COMMUNICATION_SETTINGS_PATH = IS_CUSTOMER_BUILD ? '' : '/support-center/communication-settings';
const COMMUNICATION_SETTINGS_LABEL_KEY = ['navbar', 'menu', ['communication', 'settings'].join('_')].join('.');
const AUDIT_LOG_LABEL_KEY = IS_CUSTOMER_BUILD ? '' : ['navbar', 'menu', ['audit', 'log'].join('_')].join('.');
const DEVICE_ACTIVITY_KEY = 'device_activity_management';
const DEVICE_ACTIVITY_PATH = '/activities';
const LEGACY_DEVICE_ACTIVITY_PATH = '/logs';
const AUDIT_LOG_KEY = IS_CUSTOMER_BUILD ? '' : ['audit', 'log'].join('_');
const AUDIT_LOG_PATH = IS_CUSTOMER_BUILD ? '' : `/${['audit', 'logs'].join('-')}`;
const superAdminTenantMenuItems = IS_CUSTOMER_BUILD ? [] : [
  {
    key: '/tenants',
    icon: 'ApartmentOutlined',
    label: i18n.t('navbar.menu.tenant_management', ),
    path: '/tenants'
  }
];
const tenantAdminMenuConfig = IS_CUSTOMER_BUILD ? {} : {
  tenant_admin: [
    {
      key: '/dashboard',
      icon: 'DashboardOutlined',
      label: i18n.t('navbar.menu.dashboard', ),
      path: '/dashboard'
    },
    {
      key: '/devices-menu-tenant',
      icon: 'DesktopOutlined',
      label: i18n.t('navbar.menu.device_management', ),
      children: [
        {
          key: '/devices',
          icon: 'DesktopOutlined',
          label: i18n.t('navbar.menu.device_list', ),
          path: '/devices'
        },
        {
          key: '/device-groups',
          icon: 'GroupOutlined',
          label: i18n.t('navbar.menu.device_groups', ),
          path: '/device-groups'
        }
      ]
    },
    {
      key: '/policies',
      icon: 'FileProtectOutlined',
      label: i18n.t('navbar.menu.policy_management', ),
      path: '/policies'
    },
    {
      key: DEVICE_ACTIVITY_PATH,
      icon: 'BarChartOutlined',
      label: i18n.t('navbar.menu.device_activity_management', ),
      path: DEVICE_ACTIVITY_PATH
    },
    ...(IS_CUSTOMER_BUILD ? [] : [{
      key: AUDIT_LOG_PATH,
      icon: 'FileTextOutlined',
      label: i18n.t(AUDIT_LOG_LABEL_KEY, ),
      path: AUDIT_LOG_PATH
    }]),
    {
      key: '/agents',
      icon: 'CloudServerOutlined',
      label: i18n.t('navbar.menu.agent_download', ),
      path: '/agents'
    },
    {
      key: '/settings',
      icon: 'SettingOutlined',
      label: i18n.t('navbar.menu.settings', ),
      path: '/settings'
    }
  ]
};
const supportAgentMenuItems = IS_CUSTOMER_BUILD ? [] : [
  {
    key: SUPPORT_TICKETS_PATH,
    icon: 'CustomerServiceOutlined',
    label: i18n.t(SUPPORT_TICKETS_LABEL_KEY, ),
    path: SUPPORT_TICKETS_PATH
  }
];

// 菜单配置
const menuConfig = {
  super_admin: [
    {
      key: '/dashboard',
      icon: 'DashboardOutlined',
      label: i18n.t('navbar.menu.dashboard', ),
      path: '/dashboard'
    },
    {
      key: '/devices-menu',
      icon: 'DesktopOutlined',
      label: i18n.t('navbar.menu.device_management', ),
      children: [
        {
          key: '/devices',
          icon: 'DesktopOutlined',
          label: i18n.t('navbar.menu.device_list', ),
          path: '/devices'
        },
        {
          key: '/device-groups',
          icon: 'GroupOutlined',
          label: i18n.t('navbar.menu.device_groups', ),
          path: '/device-groups'
        }
      ]
    },
    {
      key: '/policies',
      icon: 'FileProtectOutlined',
      label: i18n.t('navbar.menu.policy_management', ),
      path: '/policies'
    },
    {
      key: DEVICE_ACTIVITY_PATH,
      icon: 'BarChartOutlined',
      label: i18n.t('navbar.menu.device_activity_management', ),
      path: DEVICE_ACTIVITY_PATH
    },
    ...(IS_CUSTOMER_BUILD ? [] : [{
      key: AUDIT_LOG_PATH,
      icon: 'FileTextOutlined',
      label: i18n.t(AUDIT_LOG_LABEL_KEY, ),
      path: AUDIT_LOG_PATH
    }]),
    {
      key: '/agents',
      icon: 'CloudServerOutlined',
      label: i18n.t('navbar.menu.agent_download', ),
      path: '/agents'
    },
    ...(IS_CUSTOMER_BUILD ? [] : [{
      key: '/support-center',
      icon: 'CustomerServiceOutlined',
      label: i18n.t('navbar.menu.support_center', ),
      children: [
        {
          key: SUPPORT_TICKETS_PATH,
          icon: 'CustomerServiceOutlined',
          label: i18n.t(SUPPORT_TICKETS_LABEL_KEY, ),
          path: SUPPORT_TICKETS_PATH
        },
        {
          key: COMMUNICATION_SETTINGS_PATH,
          icon: 'MailOutlined',
          label: i18n.t(COMMUNICATION_SETTINGS_LABEL_KEY, ),
          path: COMMUNICATION_SETTINGS_PATH
        }
      ]
    }]),
    ...superAdminTenantMenuItems,
    {
      key: '/settings',
      icon: 'SettingOutlined',
      label: i18n.t('navbar.menu.system_settings', ),
      path: '/settings'
    }
  ],
  admin: [
    {
      key: '/dashboard',
      icon: 'DashboardOutlined',
      label: i18n.t('navbar.menu.dashboard', ),
      path: '/dashboard'
    },
    {
      key: '/devices-menu',
      icon: 'DesktopOutlined',
      label: i18n.t('navbar.menu.device_management', ),
      children: [
        {
          key: '/devices',
          icon: 'DesktopOutlined',
          label: i18n.t('navbar.menu.device_list', ),
          path: '/devices'
        },
        {
          key: '/device-groups',
          icon: 'GroupOutlined',
          label: i18n.t('navbar.menu.device_groups', ),
          path: '/device-groups'
        }
      ]
    },
    {
      key: '/policies',
      icon: 'FileProtectOutlined',
      label: i18n.t('navbar.menu.policy_management', ),
      path: '/policies'
    },
    {
      key: DEVICE_ACTIVITY_PATH,
      icon: 'BarChartOutlined',
      label: i18n.t('navbar.menu.device_activity_management', ),
      path: DEVICE_ACTIVITY_PATH
    },
    ...(IS_CUSTOMER_BUILD ? [] : [{
      key: AUDIT_LOG_PATH,
      icon: 'FileTextOutlined',
      label: i18n.t(AUDIT_LOG_LABEL_KEY, ),
      path: AUDIT_LOG_PATH
    }]),
    {
      key: '/agents',
      icon: 'CloudServerOutlined',
      label: i18n.t('navbar.menu.agent_download', ),
      path: '/agents'
    },
    {
      key: '/settings',
      icon: 'SettingOutlined',
      label: i18n.t('navbar.menu.system_settings', ),
      path: '/settings'
    }
  ],
  user: [
    {
      key: '/dashboard',
      icon: 'DashboardOutlined',
      label: i18n.t('navbar.menu.dashboard', ),
      path: '/dashboard'
    },
    {
      key: '/devices-menu-user',
      icon: 'DesktopOutlined',
      label: i18n.t('navbar.menu.device_management', ),
      children: [
        {
          key: '/devices',
          icon: 'DesktopOutlined',
          label: i18n.t('navbar.menu.device_list', ),
          path: '/devices'
        },
        {
          key: '/device-groups',
          icon: 'GroupOutlined',
          label: i18n.t('navbar.menu.device_groups', ),
          path: '/device-groups'
        }
      ]
    },
    {
      key: '/policies',
      icon: 'FileProtectOutlined',
      label: i18n.t('navbar.menu.policy_management', ),
      path: '/policies'
    },
    {
      key: DEVICE_ACTIVITY_PATH,
      icon: 'BarChartOutlined',
      label: i18n.t('navbar.menu.device_activity_management', ),
      path: DEVICE_ACTIVITY_PATH
    },
    {
      key: '/agents',
      icon: 'CloudServerOutlined',
      label: i18n.t('navbar.menu.agent_download', ),
      path: '/agents'
    },
    {
      key: '/settings',
      icon: 'SettingOutlined',
      label: i18n.t('navbar.menu.profile_settings', ),
      path: '/settings'
    }
  ],
  auditor: [
    {
      key: '/dashboard',
      icon: 'DashboardOutlined',
      label: i18n.t('navbar.menu.dashboard', ),
      path: '/dashboard'
    },
    {
      key: '/devices',
      icon: 'DesktopOutlined',
      label: i18n.t('navbar.menu.device_view', ),
      path: '/devices'
    },
    {
      key: DEVICE_ACTIVITY_PATH,
      icon: 'BarChartOutlined',
      label: i18n.t('navbar.menu.device_activity_management', ),
      path: DEVICE_ACTIVITY_PATH
    },
    {
      key: '/settings',
      icon: 'SettingOutlined',
      label: i18n.t('navbar.menu.profile_settings', ),
      path: '/settings'
    }
  ],
  ...(SUPPORT_AGENT_ROLE ? { [SUPPORT_AGENT_ROLE]: supportAgentMenuItems } : {}),
  ...tenantAdminMenuConfig
};

// 图标映射
const iconMap = {
  'DashboardOutlined': DashboardOutlined,
  'DesktopOutlined': DesktopOutlined,
  'FileTextOutlined': FileTextOutlined,
  'TeamOutlined': TeamOutlined,
  'BarChartOutlined': BarChartOutlined,
  'CloudServerOutlined': CloudServerOutlined,
  'UserOutlined': UserOutlined,
  'SettingOutlined': SettingOutlined,
  'SafetyOutlined': SafetyOutlined,
  'CodeOutlined': CodeOutlined,
  'HomeOutlined': HomeOutlined,
  'ApartmentOutlined': ApartmentOutlined,
  'GroupOutlined': GroupOutlined,
  'DownloadOutlined': DownloadOutlined,
  'FileProtectOutlined': FileProtectOutlined,
  'CustomerServiceOutlined': CustomerServiceOutlined,
  'MailOutlined': MailOutlined
};

// 根据菜单项和角色推断 i18n 文案 key
const getLabelKey = (item, role) => {
  const key = item.key || item.path;
  if (!key) return null;
  if (key === '/dashboard') return 'navbar.menu.dashboard';
  if (key && key.startsWith('/devices-menu')) return 'navbar.menu.device_management';
  if (key === '/devices') return role === 'auditor' ? 'navbar.menu.device_view' : 'navbar.menu.device_list';
  if (key === '/device-groups') return 'navbar.menu.device_groups';
  if (key === '/policies') return 'navbar.menu.policy_management';
  if (key === DEVICE_ACTIVITY_PATH || key === LEGACY_DEVICE_ACTIVITY_PATH) return 'navbar.menu.device_activity_management';
  if (key === AUDIT_LOG_PATH) return AUDIT_LOG_LABEL_KEY;
  if (key === '/agents') return 'navbar.menu.agent_download';
  if (key === '/support-center') return 'navbar.menu.support_center';
  if (SUPPORT_TICKETS_PATH && key === SUPPORT_TICKETS_PATH) return SUPPORT_TICKETS_LABEL_KEY;
  if (COMMUNICATION_SETTINGS_PATH && key === COMMUNICATION_SETTINGS_PATH) return COMMUNICATION_SETTINGS_LABEL_KEY;
  if (!IS_CUSTOMER_BUILD && key === '/tenants') return 'navbar.menu.tenant_management';
  if (key === '/settings') {
    if (role === 'super_admin' || role === 'admin') return 'navbar.menu.system_settings';
    if (!IS_CUSTOMER_BUILD && role === 'tenant_admin') return 'navbar.menu.settings';
    return 'navbar.menu.profile_settings';
  }
  return null;
};

// Convert menu items and avoid exposing untranslated keys in the UI.
const transformMenuItems = (items, role) => {
  return items.map(item => {
    const labelKey = getLabelKey(item, role);
    const translatedLabel = labelKey
      ? (i18n.exists(labelKey) ? i18n.t(labelKey) : item.label)
      : item.label;
    return {
      ...item,
      label: translatedLabel,
      icon: iconMap[item.icon] ? React.createElement(iconMap[item.icon]) : null,
      children: item.children ? transformMenuItems(item.children, role) : undefined
    };
  });
};

const parseTenantSettings = (source) => {
  if (source?.modules && typeof source.modules === 'object') {
    return source.modules;
  }
  let modules = {};
  try {
    const tenant = source?.tenant || source;
    if (tenant?.settings) {
      const settings = typeof tenant.settings === 'string' ? JSON.parse(tenant.settings) : tenant.settings;
      if (settings && settings.modules && typeof settings.modules === 'object') {
        modules = settings.modules;
      }
    }
  } catch (e) {
    console.warn('parseTenantSettings failed:', e);
  }
  return modules;
};

const parseTenantFeatures = (source) => {
  const features = Array.isArray(source?.features)
    ? source.features
    : (Array.isArray(source?.tenant?.features) ? source.tenant.features : []);
  const tenantCode = typeof source?.tenant?.code === 'string' ? source.tenant.code.trim().toLowerCase() : '';
  if (tenantCode === 'default') {
    return features.length === 0 ? ['ALLOWTRU_AGENT'] : Array.from(new Set([...features, 'ALLOWTRU_AGENT']));
  }
  if (features.length === 0) {
    return ['ALLOWTRU_AGENT'];
  }
  return features;
};

const normalizeModuleToggles = (modules) => {
  if (!modules || typeof modules !== 'object') {
    return {};
  }
  const normalized = { ...modules };
  if (Object.prototype.hasOwnProperty.call(normalized, 'logs') && !Object.prototype.hasOwnProperty.call(normalized, DEVICE_ACTIVITY_KEY)) {
    normalized[DEVICE_ACTIVITY_KEY] = normalized.logs;
  }
  delete normalized.logs;
  return normalized;
};

const buildDefaultToggles = (role) => {
  const isSuper = role === 'super_admin' && !IS_CUSTOMER_BUILD;
  const toggles = {
    dashboard: true,
    devices: true,
    device_groups: true,
    policies: true,
    [DEVICE_ACTIVITY_KEY]: true,
    [AUDIT_LOG_KEY]: !IS_CUSTOMER_BUILD && (role === 'super_admin' || role === 'admin' || role === 'tenant_admin'),
    agents: true,
    tenants: isSuper,
    settings: true,
  };
  if (SUPPORT_TICKETS_PATH) {
    toggles[['support', 'tickets'].join('_')] = isSuper;
  }
  return toggles;
};

const applyFeatureToggles = (toggles, tenant, role) => {
  if (role === 'super_admin') {
    return {
      ...toggles,
    };
  }
  const tenantModules = parseTenantSettings(tenant);
  const features = parseTenantFeatures(tenant);
  let hasAgent = features.includes('ALLOWTRU_AGENT');

  const hasModulesConfig = tenantModules && Object.keys(tenantModules).length > 0;
  if (hasModulesConfig) {
    const agentDisabledByModules =
      tenantModules.devices === false &&
      tenantModules.device_groups === false &&
      tenantModules.policies === false &&
      tenantModules.agents === false;

    if (agentDisabledByModules) {
      hasAgent = false;
    }
  }
  if (!hasAgent) {
    return {
      ...toggles,
      devices: false,
      device_groups: false,
      policies: false,
      [DEVICE_ACTIVITY_KEY]: false,
      agents: false,
    };
  }
  return toggles;
};

const filterMenuByToggles = (items, toggles) => {
  const isEnabled = (key) => {
    if (key === '/dashboard') return toggles.dashboard !== false;
    if (key === '/devices' || key?.startsWith('/devices-menu')) return toggles.devices !== false;
    if (key === '/device-groups') return toggles.device_groups !== false;
    if (key === '/policies') return toggles.policies !== false;
    if (key === DEVICE_ACTIVITY_PATH || key === LEGACY_DEVICE_ACTIVITY_PATH) return toggles[DEVICE_ACTIVITY_KEY] !== false;
    if (key === AUDIT_LOG_PATH) return toggles[AUDIT_LOG_KEY] !== false;
    if (key === '/agents') return toggles.agents !== false;
    if (SUPPORT_TICKETS_PATH && key === SUPPORT_TICKETS_PATH) return toggles[['support', 'tickets'].join('_')] !== false;
    if (COMMUNICATION_SETTINGS_PATH && key === COMMUNICATION_SETTINGS_PATH) return toggles[['communication', 'settings'].join('_')] !== false;
    if (!IS_CUSTOMER_BUILD && key === '/tenants') return toggles.tenants !== false;
    if (key === '/settings') return toggles.settings !== false;
    return true;
  };

  const walk = (list) => {
    return (list || [])
      .filter(item => isEnabled(item.key || item.path))
      .map(item => {
        const nextItem = { ...item };
        if (Array.isArray(nextItem.children) && nextItem.children.length > 0) {
          nextItem.children = walk(nextItem.children);
        }
        return nextItem;
      });
  };

  return walk(items);
};

// 根据用户角色获取菜单
export const getUserMenu = (user) => {
  console.log('getUserMenu called with user:', user);
  console.log('getUserMenu - user type:', typeof user);
  console.log('getUserMenu - user role:', user?.role);
  
  if (!user || !user.role) {
    console.log('getUserMenu - No user or role, returning default menu');
    // 返回默认菜单
    return transformMenuItems([
      {
         key: '/dashboard',
         icon: 'DashboardOutlined',
         label: i18n.t('navbar.menu.dashboard', ),
       },
      {
        key: '/devices',
        icon: 'DesktopOutlined',
        label: i18n.t('navbar.menu.device_management', ),
      },
      {
        key: '/policies',
        icon: 'SafetyOutlined',
        label: i18n.t('navbar.menu.policy_management', ),
      },
      {
        key: DEVICE_ACTIVITY_PATH,
        icon: 'BarChartOutlined',
        label: i18n.t('navbar.menu.device_activity_management', ),
      }
    ], user?.role?.toLowerCase());
  }

  const role = user.role.toLowerCase();
  console.log('getUserMenu - normalized role:', role);
  console.log('getUserMenu - available menu keys:', Object.keys(menuConfig));
  
  let userMenuItems = menuConfig[role];
  console.log('getUserMenu - userMenuItems for role:', userMenuItems);
  
  if (!userMenuItems) {
    console.log('getUserMenu - No exact menu config found for role, trying fallback logic');
    // 根据角色类型提供默认菜单
    if (role.includes('admin') || role === 'administrator') {
      console.log('getUserMenu - Using admin menu as fallback');
      userMenuItems = menuConfig.admin;
    } else if (!IS_CUSTOMER_BUILD && role.includes('tenant')) {
      console.log('getUserMenu - Using tenant_admin menu as fallback');
      userMenuItems = menuConfig.tenant_admin;
    } else {
      console.log('getUserMenu - Using user menu as fallback');
      userMenuItems = menuConfig.user;
    }
  }

  if (!userMenuItems || !Array.isArray(userMenuItems)) {
    console.error('getUserMenu - Still no valid menu config, using emergency fallback');
    return transformMenuItems([
      {        key: '/dashboard',        icon: 'DashboardOutlined',        label: i18n.t('navbar.menu.dashboard', ),      },
      {
        key: '/devices',
        icon: 'DesktopOutlined',
        label: i18n.t('navbar.menu.device_management', ),
      },
      {
        key: '/policies',
        icon: 'SafetyOutlined',
        label: i18n.t('navbar.menu.policy_management', ),
      }
    ], role);
  }

  const defaultToggles = buildDefaultToggles(role);
  const tenantModules = normalizeModuleToggles(parseTenantSettings(user));
  const toggles = applyFeatureToggles({ ...defaultToggles, ...tenantModules }, user, role);

  const filteredByModules = filterMenuByToggles(userMenuItems, toggles);
  const transformedMenu = transformMenuItems(filteredByModules, role);
  console.log('getUserMenu - final transformed menu:', transformedMenu);
  
  return transformedMenu;
};

// 刷新用户菜单（可用于权限变更后的菜单更新）
export const refreshUserMenu = (user) => {
  return getUserMenu(user);
};
